import { EventList, EventSeriesData, PerformanceData, Stay22DTO, Stay22Data } from "../entity";

export class Stay22Factory {

    private static dataTemplate: Stay22Data = {
        location: '',
        fromDate: 0,
        venueTitle: '',
        toDate: null,
        pitch: '',
        header: '',
    }

    public static getDataFrom(data: Stay22DTO): Stay22Data | null {
        const eventList: EventList = data.eventList;
        const event: EventSeriesData | PerformanceData = eventList.events[0];

        if (!event) {
            return null;
        }

        const eventData: Partial<Stay22Data> = "location" in event ? this.fromEventList(event) : this.fromPerformance(event);

        return {
            ...this.dataTemplate,
            ...eventData,
            pitch: this.getPitchFrom(data, eventData.venueTitle),
            header: data.header,
        };
    }

    private static getPitchFrom(data: Stay22DTO, venueTitle: string | undefined): string {
        return data.pitch.replace('{var}venueTitle{/var}', venueTitle ?? '');
    }

    private static fromPerformance(event: PerformanceData): Partial<Stay22Data> {
        const street = event.street ?? '';
        const city = event.cityName ?? '';
        const venue = event.venueName ?? '';

        return {
            location: this.buildLocationFrom(street, venue, city),
            fromDate: event.startDate,
            venueTitle: venue + (venue && city ? ', ' : '') + city,
            toDate: event.endDate ?? null,
        }
    }

    private static fromEventList(event: EventSeriesData): Partial<Stay22Data> {
        const location = event.location[0];
        const street = location.street ?? '';
        const city = location.city ?? '';
        const venue = location.venue ?? '';

        return {
            location: this.buildLocationFrom(street, venue, city),
            fromDate: new Date(event.fromDate.dateTime).getTime() / 1000,
            venueTitle: venue + (venue && city ? ', ' : '') + city,
            toDate: event.toDate ? new Date(event.toDate.dateTime).getTime() / 1000 : null,
        }
    }

    private static buildLocationFrom(street: string, venue: string, city: string): string {
        let location: string[] = [];

        if (street) {
            location.push(street);
        } else {
            location.push(venue);
        }

        if (city) {
            location.push(city);
        }

        return location.join(', ');
    }

}
